import Router from 'next/router';
import React from 'react';
import { CustomError } from './errors';

type ErrorBoundaryProps = React.PropsWithChildren<{
  fallback?: React.ReactNode;
  name?: string;
}>;

interface ErrorBoundaryState {
  error: Error | null;
}

const errorBoundaryState: ErrorBoundaryState = {
  error: null,
};

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = errorBoundaryState;
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidMount() {
    Router.events.on('routeChangeStart', this.resetState);
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    const { name = 'global' } = this.props;

    console.error(`${name} ErrorBoundary error`, error);
    console.error(`${name} ErrorBoundary componentStack`, errorInfo.componentStack);
  }

  componentWillUnmount() {
    Router.events.off('routeChangeStart', this.resetState);
  }

  private resetState = () => {
    this.setState(errorBoundaryState);
  };

  render() {
    const { error } = this.state;
    const { children, fallback } = this.props;

    const Fallback = typeof fallback !== 'undefined' ? fallback : <CustomError />;

    return error ? Fallback : children;
  }
}
